module.exports = __webpack_public_path__ + "static/media/plus.0f783d8c.svg";